import { Box, Divider } from '@mui/material';
import { IncomingConnectionSection } from './IncomingConnectionSection';
import { OutgoingConnectionSection } from './OutgoingConnectionSection';
import { ConnectedSection } from './ConnectedSection';
import { useUserConnection } from '../hook/useUserConnection';
import { ConnectionDispatchProvider } from './ConnectionDispatchProvider';
import { useMarkNotificationAsRead } from '../../notification/hooks/useMarkNotificationAsRead';

export const CommunityConnections = () => {
  const {
    connectionDispatch,
    incomingConnections,
    outgoingConnections,
    connectedConnections,
  } = useUserConnection();

  useMarkNotificationAsRead();

  return (
    <ConnectionDispatchProvider dispatch={connectionDispatch}>
      <Box sx={{ mt: 10 }}>
        {incomingConnections.connections.length > 0 && (
          <>
            <IncomingConnectionSection
              incomingConnections={incomingConnections}
            />
            <Divider sx={{ my: 5 }} />
          </>
        )}
        {outgoingConnections.connections.length > 0 && (
          <>
            <OutgoingConnectionSection
              outgoingConnections={outgoingConnections}
            />
            <Divider sx={{ my: 5 }} />
          </>
        )}
        <ConnectedSection connectedConnections={connectedConnections} />
      </Box>
    </ConnectionDispatchProvider>
  );
};
